<template>
    <div class="w-100 home-page">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2>{{ $t('you_are_logged_in') }}</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        layout: 'default',

        metaInfo () {
            return { title: this.$t('home') }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/home.vue